export type TRedesignStickyBarPhase = 'beforeOffers' | 'onOffers' | 'afterOffers';

const OFFERS_REACHED_VIEWPORT_RATIO = 0.75;

/**
 * Определяет фазу sticky bar относительно блока предложений.
 * На initial load (scrollY === 0) удерживает beforeOffers, даже если якорь виден без скролла.
 */
export const computeStickyBarPhase = (
  listingRect: DOMRect,
  viewportHeight: number,
  offersAnchorRect?: DOMRect | null,
  scrollY = 0,
): TRedesignStickyBarPhase => {
  if (listingRect.bottom <= 0) {
    return 'afterOffers';
  }

  const anchorRect = offersAnchorRect ?? listingRect;
  const reachedThreshold = viewportHeight * OFFERS_REACHED_VIEWPORT_RATIO;

  if (anchorRect.top <= reachedThreshold) {
    if (scrollY === 0 && anchorRect.top > 0) {
      return 'beforeOffers';
    }

    return 'onOffers';
  }

  if (anchorRect.top >= viewportHeight) {
    return 'beforeOffers';
  }

  return 'beforeOffers';
};
